import React from 'react'
import WaitingLobbyCard from '../components/pre_game/WaitingLobbyCard';
import { Box } from '@mui/material';


function WaitingLobbyPage() {
    return (
        <Box>
            <WaitingLobbyCard />
            <details className="creative-quick-rules"><summary>How to play</summary><ol><li>Two players answer each prompt with their eyes closed.</li><li>Agree? Take a sip or raise a hand. Same answer? Double trouble.</li><li>The next player guesses who wrote it. The host reveals the author and scores the guess.</li></ol></details>
        </Box>
    )
}

export default WaitingLobbyPage
